module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "user-activity-log-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("USER ACTIVITY LOG FOR: " + _vm._s(_vm.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(!_vm.loading) ? _c('date-picker', {
    attrs: {
      "placeholder": "Select Date Range",
      "lang": "en",
      "range-separator": "-",
      "format": _vm.format,
      "value-type": 'YYYY-MM-DD',
      "range": true,
      "confirm": false,
      "prefix-class": "xmx"
    },
    on: {
      "change": _vm.changeDate
    },
    model: {
      value: (_vm.range),
      callback: function($$v) {
        _vm.range = $$v
      },
      expression: "range"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('a', {
    staticClass: "pull-right btn btn-circle btn-icon-only btn-default",
    attrs: {
      "href": _vm.getExportUrl()
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.loading) ? _c('spinner') : [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "pagination-options": {
        'enabled': false
      }
    }
  }, [_vm._v("\n                        >\n                        "), _c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            No logs available.\n                        ")])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "page-count": _vm.pages,
      "page-range": 1,
      "margin-pages": 1,
      "initialPage": _vm.page - 1,
      "click-handler": _vm.changePage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination pagination-sm'
    }
  })]], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f5cd7c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/UserActivityLogModal.vue
// module id = 1598
// module chunks = 1